'use strict';

var React = require('react');

var SvgVolumeMinor = function SvgVolumeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 3a1 1 0 0 0-1-1h-14a1 1 0 0 0 0 2h1v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-12h1a1 1 0 0 0 1-1Zm-4 1h-8v7h8v-2h-2a1 1 0 1 1 0-2h2v-3Z"
  }));
};

exports.SvgVolumeMinor = SvgVolumeMinor;
